export default __webpack_public_path__ + "static/media/arrow.12cd8742.svg";